export class HTTPError extends Error {
    public status: number;
    public statusText: string;
    public $type: string;

    constructor(status: number, statusText: string) {
        super(
            `HTTP ${status}` +
                (statusText != null && statusText !== ''
                    ? `: ${statusText}`
                    : '')
        );
        this.status = status;
        this.statusText = statusText;
        this.$type = 'HTTPError';
    }
}
